import posthog from "posthog-js";
import { getVisitorId } from "./visitor";
import { ENV } from "./env";
import { getConsent } from "./consent";

let initialized = false;

export function initPostHog() {
  if (initialized || typeof window === "undefined" || !ENV.POSTHOG_KEY) return;
  if (getConsent() !== "accepted") return;
  posthog.init(ENV.POSTHOG_KEY, {
    api_host: ENV.POSTHOG_HOST,
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    persistence: "localStorage+cookie",
    session_recording: {},
  });
  posthog.identify(getVisitorId());
  initialized = true;
}

export { posthog };
